import React from 'react';

export class RenderProdRectangle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            labelWidths: {
                top: 0,
                middle: 0,
                middle2: 0,
                bottom: 0
            },
        };
        this.textRefs = {
            top: React.createRef(),
            middle: React.createRef(),
            middle2: React.createRef(),
            bottom: React.createRef()
        };
    }
    
    componentDidMount() {
        this.updateLabelWidths();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.prodObj?.imageUrl !== this.props.prodObj?.imageUrl) {
            this.updateLabelWidths();
        }
    }

    updateLabelWidths = () => {
        setTimeout(() => {
            this.setState({
                labelWidths: {
                    top: this.textRefs.top.current?.getBBox().width + 10 || 50,
                    middle: this.textRefs.middle.current?.getBBox().width + 10 || 50,
                    middle2: this.textRefs.middle2.current?.getBBox().width + 10 || 50,
                    bottom: this.textRefs.bottom.current?.getBBox().width + 10 || 50
                }
            });
        }, 0);
    };

    conditionallyForceLTR(text) {
        const hasLTR = /[A-Za-z]/.test(text);
        const hasSuspiciousSymbols = /[<>/=]/.test(text);
        const isLikelyLTR = hasLTR && hasSuspiciousSymbols;
        
        if (isLikelyLTR) {
            const LRI = '\u2066';
            const PDI = '\u2069';
            return `${LRI}${text}${PDI}`;
        }
        
        return text;
        }

    render() {
        const { prodObj, rectangleColor = "white" , isPriceTag=false } = this.props;
        const { labelWidths } = this.state;

        let topRectX = prodObj?.x + ((prodObj?.isEvenGroup !== undefined && prodObj?.isEvenGroup) ? (- labelWidths.top / 2) : ((prodObj?.drawWidth - labelWidths.top) / 2));
        let topRectTextX = prodObj?.x + ((prodObj?.isEvenGroup !== undefined && prodObj?.isEvenGroup) ? 0 : (prodObj?.drawWidth / 2));

        let topLabelY = prodObj.y - 18;

        // PRICE TAG CR
        if (isPriceTag && prodObj?.isHanged && prodObj?.hasPriceTag) {
            topLabelY = prodObj.y - ((prodObj.priceTagHeight*this.props.fullScreenRatio) + (prodObj.priceTagGap*this.props.fullScreenRatio)) -18;
        }

        return (
            <>
                {/* Main Rectangle */}
                <rect 
                    x={prodObj?.x} 
                    y={prodObj?.y} 
                    width={prodObj?.drawWidth} 
                    height={prodObj?.drawHeight} 
                    fill={rectangleColor}
                    style={{outline: prodObj?.mark_height_issue === true ? "solid 4px red" : "solid 1px rgb(204, 204, 204)"}}
                />

                {/* Show hangged peg hole in red color */}
                {prodObj?.isHanged && 
                  <circle key={prodObj?.pegRefCode} cx={prodObj?.pegDrawX} cy={prodObj?.pegDrawY-40} r={2} fill="red" stroke="red" />
                 }

                {/* Top Label */}
                {this.props.isStack && this.props?.topLabel && (
                    <>
                    <rect 
                        // x={prodObj.x + (prodObj.drawWidth - labelWidths.top) / 2} 
                        x={topRectX} 
                        // y={prodObj.y - (prodObj.drawHeight * this.props.lastIndex) +12} 
                         y={topLabelY} 
                        width={labelWidths.top} 
                        height={18} 
                        fill={this.props.labelColor || "white"} 
                        stroke="black"
                    />
                    <text 
                        ref={this.textRefs.top}
                        // x={prodObj.x + prodObj.drawWidth / 2} 
                        x={topRectTextX} 
                        // y={prodObj.y - (prodObj.drawHeight * this.props.lastIndex) + 27} 
                        y={topLabelY + 15} 
                        fill="black" 
                        fontSize="16" 
                        textAnchor="middle"
                    >
                        {this.props?.topLabel}
                    </text>
                    </>
                )}

                {/* Product Face Label */}
                 {this.props.isStack &&this.props?.productFace && (
                    <>
                    <rect 
                        x={prodObj.x + (prodObj.drawWidth - labelWidths.middle2) / 2} 
                        // y={prodObj.y + prodObj.drawHeight / 2 - 20} 
                        // y={prodObj.y + prodObj.drawHeight / 2 - (this.props?.middleLabel === null ? 6 : 20)}
                        y={
                            (this.props?.middleLabel !== null && this.props?.middleLabel?.length > 0) 
                            ? (prodObj.y + prodObj.drawHeight / 2 - 13) 
                            : (prodObj.y + prodObj.drawHeight / 2 - 6)
                        }
                        width={labelWidths.middle2} 
                        height={18}
                        fill={this.props.labelColor || "white"} 
                        stroke="black"
                    />
                    <text 
                        ref={this.textRefs.middle2}
                        x={prodObj.x + prodObj.drawWidth / 2} 
                        // y={prodObj.y + prodObj.drawHeight / 2 - 10} 
                        // y={prodObj.y + prodObj.drawHeight / 2 - (this.props?.middleLabel === null ?  -3: 10)} 
                        y={
                            (this.props?.middleLabel !== null && this.props?.middleLabel?.length > 0) 
                            ? (prodObj.y + prodObj.drawHeight / 2 - 1)
                            : (prodObj.y + prodObj.drawHeight / 2 + 9)
                        }
                       
                        fill="black" 
                        fontSize="16"
                        fontWeight="medium"
                        textAnchor="middle"
                    >
                        {this.props?.productFace}
                    </text>
                    </>
                )}
          
                {/* Middle Label */}
                {this.props.isStack &&this.props?.middleLabel && (
                    <>
                    <rect 
                        x={prodObj.x + (prodObj.drawWidth - labelWidths.middle) / 2} 
                        y={prodObj.y + prodObj.drawHeight / 2 + 3} 
                        width={labelWidths.middle} 
                        height={18} 
                        fill={this.props.labelColor || "white"} 
                        stroke="black"
                    />
                    <text 
                    direction="rtl"
                        ref={this.textRefs.middle}
                        x={prodObj.x + prodObj.drawWidth / 2} 
                        y={prodObj.y + prodObj.drawHeight / 2 + 17} 
                        fill="black" 
                        fontSize="16"
                        fontWeight="medium"
                        textAnchor="middle"
                    >

                        {/* {this.props?.middleLabel} */}
                        {this.conditionallyForceLTR(this.props?.middleLabel)}
                    </text>
                    </>
                )}

                {/* Bottom Label */}
                {this.props.isStack &&this.props?.bottomLabel && (
                    <>
                    <rect 
                        x={prodObj.x + (prodObj.drawWidth - labelWidths.bottom) / 2} 
                        y={prodObj.y + prodObj.drawHeight - 18} 
                        width={labelWidths.bottom} 
                        height={18} 
                        fill={this.props.labelColor || "white"} 
                        stroke="black"
                    />
                    <text 
                        ref={this.textRefs.bottom}
                        x={prodObj.x + prodObj.drawWidth / 2} 
                        y={prodObj.y + prodObj.drawHeight -4 } 
                        fill="black" 
                        fontSize="16" 
                        textAnchor="middle"
                    >
                        {this.props?.bottomLabel}
                    </text>
                    </>
                )}
            </>
        );
    }
}

export class RenderStackProdRectangle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            labelWidths: {
                top: 0,
                middle: 0,
                middle2: 0,
                bottom: 0
            },
        };
        this.textRefs = {
            top: React.createRef(),
            middle: React.createRef(),
            middle2: React.createRef(),
            bottom: React.createRef()
        };
    }
    
    componentDidMount() {
        this.updateLabelWidths();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.prodObj?.imageUrl !== this.props.prodObj?.imageUrl) {
            this.updateLabelWidths();
        }
    }

    updateLabelWidths = () => {
        setTimeout(() => {
            this.setState({
                labelWidths: {
                    top: this.textRefs.top.current?.getBBox().width + 10 || 50,
                    middle: this.textRefs.middle.current?.getBBox().width + 10 || 50,
                    middle2: this.textRefs.middle2.current?.getBBox().width + 10 || 50,
                    bottom: this.textRefs.bottom.current?.getBBox().width + 10 || 50
                }
            });
        }, 0);
    };

    render() {
        const { prodObj, rectangleColor = "white" } = this.props;
        const { labelWidths } = this.state;
     
        let topRectX = prodObj.x + ((prodObj?.isEvenGroup !== undefined && prodObj?.isEvenGroup) ? (- labelWidths.top / 2) : ((prodObj.drawWidth - labelWidths.top) / 2));
        let topRectTextX = prodObj.x + ((prodObj?.isEvenGroup !== undefined && prodObj?.isEvenGroup) ? 0  : (prodObj.drawWidth / 2));

        return (
            <>
                {/* Main Rectangle */}
                <rect 
                    x={prodObj.x} 
                    y={prodObj.y - prodObj.drawHeight*this.props.index} 
                    width={prodObj.drawWidth} 
                    height={prodObj.drawHeight} 
                    fill={rectangleColor}
                    style={{outline: prodObj?.mark_height_issue === true ? "solid 4px red" : "solid 1px rgb(204, 204, 204)"}}
                />

                {/* Top Label */}
                {this.props?.topLabel && (
                    <>
                    <rect 
                        x={prodObj.x + (prodObj.drawWidth - labelWidths.top) / 2} 
                        //x={prodObj.x + (prodObj.drawWidth - labelWidths.top) / 2} 
                        y={prodObj.y - (prodObj.drawHeight * this.props.lastIndex) + 10} 
                        width={labelWidths.top} 
                        height={18} 
                        fill={this.props.labelColor || "white"} 
                        // style={{zIndex: 1000000}}
                        stroke="black"
                    />
                    <text 
                        ref={this.textRefs.top}
                        // x={prodObj.x + prodObj.drawWidth / 2} 
                        x={prodObj.x + prodObj.drawWidth / 2} 
                        y={prodObj.y - (prodObj.drawHeight * this.props.lastIndex) + 25}  
                        // style={{zIndex: 1000000}}
                        fill="black" 
                        fontSize="16" 
                        textAnchor="middle"
                    >
                        {this.props?.topLabel}
                    </text>
                    </>
                )}

                 {/* Product Face Label */}
                 {this.props?.productFace && (
                    <>
                    <rect 
                        x={prodObj.x + (prodObj.drawWidth - labelWidths.middle2) / 2} 
                        // y={prodObj.y + prodObj.drawHeight / 2 - 20} 
                        y={ this.props.lastIndex + 1 === 2 ? prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex) / 2) + 70 :prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex) / 2) + 30}
                        width={labelWidths.middle2} 
                        height={18} 
                        fill={this.props.labelColor || "white"} 
                        stroke="black"
                    />
                    <text 
                        ref={this.textRefs.middle2}
                        x={prodObj.x + prodObj.drawWidth / 2} 
                        // y={prodObj.y + prodObj.drawHeight / 2 - 10} 
                        y={this.props.lastIndex + 1 === 2 ? prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex) / 2) + 85: prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex) / 2) + 45} 
                        fill="black" 
                        fontSize="16"
                        fontWeight="medium"
                        textAnchor="middle"
                    >
                        {this.props?.productFace}
                    </text>
                    </>
                )}

                {/* Middle Label */}
                {this.props?.middleLabel && (
                    <>
                    <rect 
                        x={prodObj.x + (prodObj.drawWidth - labelWidths.middle) / 2} 
                        //y={prodObj.y + prodObj.drawHeight / 2 - 6} 
                        y={ this.props.lastIndex + 1 === 2 ? prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex) / 2) + 90 :prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex) / 2) + 50}
                        width={labelWidths.middle} 
                        height={18} 
                        fill={this.props.labelColor || "white"} 
                        stroke="black"
                    />
                    <text 
                        ref={this.textRefs.middle}
                        x={prodObj.x + prodObj.drawWidth / 2} 
                        // y={prodObj.y + prodObj.drawHeight / 2 + 2} 
                        y={this.props.lastIndex + 1 === 2 ? prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex) / 2) + 105: prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex) / 2) + 65} 
                        fill="black" 
                        fontSize="16"
                        fontWeight="medium"
                        textAnchor="middle"
                    >
                        {this.props?.middleLabel}
                    </text>
                    </>
                )}

                {/* Bottom Label */}
                {this.props?.bottomLabel && (
                    <>
                    <rect 
                        x={prodObj.x + (prodObj.drawWidth - labelWidths.bottom) / 2} 
                        y={prodObj.y + prodObj.drawHeight - 20} 
                        width={labelWidths.bottom} 
                        height={18} 
                        fill={this.props.labelColor || "white"} 
                        stroke="black"
                    />
                    <text 
                        ref={this.textRefs.bottom}
                        x={prodObj.x + prodObj.drawWidth / 2} 
                        y={prodObj.y + prodObj.drawHeight - 6 } 
                        fill="black" 
                        fontSize="16" 
                        textAnchor="middle"
                    >
                        {this.props?.bottomLabel}
                    </text>
                    </>
                )}
            </>
        );
    }
}

// export class RenderProdImage extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             prodUrl: null,
//             labelWidths: {
//                 top: 0,
//                 middle: 0,
//                 bottom: 0
//             },
//         };
//         this.textRefs = {
//             top: React.createRef(),
//             middle: React.createRef(),
//             bottom: React.createRef()
//         };
//     }
    
//     componentDidMount() {
//         this.getBase64FromUrl(this.props.prodObj.imageUrl).then(returnimage => {
//             this.setState({ prodUrl: returnimage });
//         });
//         this.updateLabelWidths();
//     }

//     componentDidUpdate(prevProps, prevState) {
//         if (prevProps.prodObj !== this.props.prodObj) {
//             this.updateLabelWidths();
//         }
//     }

//     getBase64FromUrl = async (url) => {
//         const data = await fetch(url);
//         const blob = await data.blob();
//         return new Promise((resolve) => {
//             const reader = new FileReader();
//             reader.readAsDataURL(blob);
//             reader.onloadend = () => {
//                 resolve(reader.result);
//             };
//         });
//     };

//     updateLabelWidths = () => {
//         setTimeout(() => {
//             this.setState({
//                 labelWidths: {
//                     top: this.textRefs.top.current?.getBBox().width + 10 || 50,
//                     middle: this.textRefs.middle.current?.getBBox().width + 10 || 50,
//                     bottom: this.textRefs.bottom.current?.getBBox().width + 10 || 50
//                 }
//             });
//         }, 0);
//     };

//     render() {
//         const { prodObj } = this.props;
//         const { prodUrl, labelWidths } = this.state;

//         return (
//             <>
//                 <image 
//                     crossOrigin='anonymous'
//                     pointerEvents="all" 
//                     preserveAspectRatio="none" 
//                     x={prodObj.x} 
//                     y={prodObj.y} 
//                     width={prodObj.drawWidth} 
//                     height={prodObj.drawHeight} 
//                     href={prodUrl ? prodUrl : prodObj.imageUrl} 
//                     style={{ outline: "solid 1px rgb(204, 204, 204)" }} 
//                 />

//                 {/* Top Label */}
//                 {this.props?.topLabel && (
//                     <>
//                     <rect 
//                     x={prodObj.x + (prodObj.drawWidth - labelWidths.top) / 2} 
//                     y={prodObj.y - 14} 
//                     width={labelWidths.top} 
//                     height={12} 
//                     fill="white" 
//                     stroke="black"
//                 />
//                 <text 
//                     ref={this.textRefs.top}
//                     x={prodObj.x + prodObj.drawWidth / 2} 
//                     y={prodObj.y - 4} 
//                     fill="black" 
//                     fontSize="10" 
//                     textAnchor="middle"
//                 >
//                     {this.props?.topLabel}
//                     </text>
//                     </>
//                 )}
                

//                 {/* Middle Label */}
//                 {this.props?.middleLabel && (
//                     <>
//                     <rect 
//                     x={prodObj.x + (prodObj.drawWidth - labelWidths.middle) / 2} 
//                     y={prodObj.y + prodObj.drawHeight / 2 - 6} 
//                     width={labelWidths.middle} 
//                     height={12} 
//                     fill="white" 
//                     stroke="black"
//                 />
//                 <text 
//                     ref={this.textRefs.middle}
//                     x={prodObj.x + prodObj.drawWidth / 2} 
//                     y={prodObj.y + prodObj.drawHeight / 2 + 2} 
//                     fill="black" 
//                     fontSize="6"
//                     fontWeight="bold"
//                     textAnchor="middle"
//                 >
//                     {this.props?.middleLabel}
//                     </text>
//                     </>

//                 )}
                

//                 {/* Bottom Label */}
//                 {this.props?.bottomLabel && (
//                     <>
//                     <rect 
//                     x={prodObj.x + (prodObj.drawWidth - labelWidths.bottom) / 2} 
//                     y={prodObj.y + prodObj.drawHeight-10} 
//                     width={labelWidths.bottom} 
//                     height={12} 
//                     fill="white" 
//                     stroke="black"
//                 />
//                 <text 
//                     ref={this.textRefs.bottom}
//                     x={prodObj.x + prodObj.drawWidth / 2} 
//                     y={prodObj.y + prodObj.drawHeight} 
//                     fill="black" 
//                     fontSize="10" 
//                     textAnchor="middle"
//                 >
//                     {this.props?.bottomLabel}
//                 </text>
//                     </>
//                 )}
                
//             </>
//         );
//     }
// }

export class RenderProdImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prodUrl: null,
            labelWidths: {
                top: 0,
                middle: 0,
                middle2: 0,
                bottom: 0
            },
        };
        this.textRefs = {
            top: React.createRef(),
            middle: React.createRef(),
            middle2: React.createRef(),
            bottom: React.createRef()
        };
    }

    async componentDidMount() {
        await this.loadImage();
        this.updateLabelWidths();
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.prodObj?.imageUrl !== this.props.prodObj?.imageUrl) {
            await this.loadImage();
            this.updateLabelWidths();
        }
    }

    loadImage = async () => {
        if (this.props.prodObj?.imageUrl) {
            try {
                const returnImage = await this.getBase64FromUrl(this.props.prodObj.imageUrl);
                this.setState({ prodUrl: returnImage });
            } catch (error) {
                console.error("Error loading image:", error);
            }
        }
    };

    getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
        });
    };

    updateLabelWidths = () => {
        setTimeout(() => {
            this.setState({
                labelWidths: {
                    top: this.textRefs.top.current?.getBBox()?.width + 10 || 50,
                    middle: this.textRefs.middle.current?.getBBox()?.width + 10 || 50,
                    middle2: this.textRefs.middle2.current?.getBBox()?.width + 10 || 50,
                    bottom: this.textRefs.bottom.current?.getBBox()?.width + 10 || 50
                }
            });
        }, 0);
    };

    render() {
        const { prodObj , isPriceTag=false } = this.props;
        const { prodUrl, labelWidths } = this.state;

        let topRectX = prodObj?.x + ((prodObj?.isEvenGroup !== undefined && prodObj?.isEvenGroup) ? (- labelWidths.top / 2) : ((prodObj?.drawWidth - labelWidths.top) / 2));
        let topRectTextX = prodObj?.x + ((prodObj?.isEvenGroup !== undefined && prodObj?.isEvenGroup) ? 0  : (prodObj?.drawWidth / 2));

        let topLabelY = prodObj.y - 18;

        //PRICE TAG CR
        if (isPriceTag && prodObj.isHanged && prodObj.hasPriceTag) {
            topLabelY = prodObj.y - ((prodObj.priceTagHeight*this.props.fullScreenRatio) + (prodObj.priceTagGap*this.props.fullScreenRatio)) -18;
        }

        return (
            <>
                <image 
                    crossOrigin='anonymous'
                    pointerEvents="all" 
                    preserveAspectRatio="none" 
                    x={prodObj?.x} 
                    y={prodObj?.y} 
                    width={prodObj?.drawWidth} 
                    height={prodObj?.drawHeight} 
                    href={prodUrl || prodObj?.imageUrl} 
                    style={{outline: prodObj?.mark_height_issue === true ? "solid 4px red" : "solid 1px rgb(204, 204, 204)"}}
                />

                {/* Show hangged peg hole in red color */}
                {prodObj?.isHanged && 
                  <circle key={prodObj?.pegRefCode} cx={prodObj?.pegDrawX} cy={prodObj?.pegDrawY-40} r={2} fill="red" stroke="red" />
                 }

                {/* Top Label */}
                {this.props.isStack && this.props?.topLabel && (
                    <>
                        <rect 
                            // x={prodObj.x + (prodObj.drawWidth - labelWidths.top) / 2} 
                            x={topRectX} 
                            y={topLabelY} 
                            width={labelWidths.top} 
                            height={18} 
                            fill="white" 
                            stroke="black"
                        />
                        <text 
                            ref={this.textRefs.top}
                            // x={prodObj.x + prodObj.drawWidth / 2} 
                            x={topRectTextX} 
                            y={topLabelY+15} 
                            fill="black" 
                            fontSize="16" 
                            textAnchor="middle"
                        >
                            {this.props?.topLabel}
                        </text>
                    </>
                )}

                   {/* Product Face Label */}
                {this.props.isStack &&this.props?.productFace && (
                    <>
                        <rect 
                            x={prodObj.x + (prodObj.drawWidth - labelWidths.middle2) / 2} 
                            // y={prodObj.y + prodObj.drawHeight / 2 - 20} 
                            y={
                                (this.props?.middleLabel !== null && this.props?.middleLabel?.length > 0) 
                                ? (prodObj.y + prodObj.drawHeight / 2 - 13) 
                                : (prodObj.y + prodObj.drawHeight / 2 - 6)
                            }
                            width={labelWidths.middle2} 
                            height={18} 
                            fill="white" 
                            stroke="black"
                        />
                        <text 
                            ref={this.textRefs.middle2}
                            x={prodObj.x + prodObj.drawWidth / 2} 
                            y={
                                (this.props?.middleLabel !== null && this.props?.middleLabel?.length > 0) 
                                ? (prodObj.y + prodObj.drawHeight / 2 - 1)
                                : (prodObj.y + prodObj.drawHeight / 2 + 9)
                            }
                            fill="black" 
                            fontSize="16"
                            fontWeight="medium"
                            textAnchor="middle"
                        >
                            {this.props?.productFace}
                        </text>
                    </>
                )}

                {/* Middle Label */}
                {this.props.isStack &&this.props?.middleLabel && (
                    <>
                        <rect 
                            x={prodObj.x + (prodObj.drawWidth - labelWidths.middle) / 2} 
                            y={prodObj.y + prodObj.drawHeight / 2 - 6} 
                            width={labelWidths.middle} 
                            height={18} 
                            fill="white" 
                            stroke="black"
                        />
                        <text 
                            ref={this.textRefs.middle}
                            x={prodObj.x + prodObj.drawWidth / 2} 
                            y={prodObj.y + prodObj.drawHeight / 2 + 2} 
                            fill="black" 
                            fontSize="16"
                            fontWeight="medium"
                            textAnchor="middle"
                        >
                            {this.props?.middleLabel}
                        </text>
                    </>
                )}

                {/* Bottom Label */}
                {this.props.isStack &&this.props?.bottomLabel && (
                    <>
                        <rect 
                            x={prodObj.x + (prodObj.drawWidth - labelWidths.bottom) / 2} 
                            y={prodObj.y + prodObj.drawHeight - 18} 
                            width={labelWidths.bottom} 
                            height={18} 
                            fill="white" 
                            stroke="black"
                        />
                        <text 
                            ref={this.textRefs.bottom}
                            x={prodObj.x + prodObj.drawWidth / 2} 
                            y={prodObj.y + prodObj.drawHeight -4} 
                            fill="black" 
                            fontSize="16" 
                            textAnchor="middle"
                        >
                            {this.props?.bottomLabel}
                        </text>
                    </>
                )}
            </>
        );
    }
}

export class RenderStackProdImage2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imageUrl: null,
            labelWidths: {
                top: 0,
                middle: 0,
                middle2: 0,
                bottom: 0
            },
        };
        this.textRefs = {
            top: React.createRef(),
            middle: React.createRef(),
            middle2: React.createRef(),
            bottom: React.createRef()
        };
    }
    
    async componentDidMount() {
        await this.loadImage();
        this.updateLabelWidths();
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.prodObj?.imageUrl !== this.props.prodObj?.imageUrl) {
            await this.loadImage();
            this.updateLabelWidths();
        }
    }

    loadImage = async () => {
        if (this.props.prodObj.imageUrl) {
            try {
                const imageUrl = await this.getBase64FromUrl(this.props.prodObj.imageUrl);
                this.setState({ imageUrl });
            } catch (error) {
                console.error("Error loading image:", error);
            }
        }
    };

    getBase64FromUrl = async (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.src = url;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL("image/png"));
            };
            img.onerror = reject;
        });
    };

    updateLabelWidths = () => {
        setTimeout(() => {
            this.setState({
                labelWidths: {
                    top: this.textRefs.top.current?.getBBox()?.width + 10 || 50,
                    middle: this.textRefs.middle.current?.getBBox()?.width + 10 || 50,
                    middle2: this.textRefs.middle2.current?.getBBox()?.width + 10 || 50,
                    bottom: this.textRefs.bottom.current?.getBBox()?.width + 10 || 50
                }
            });
        }, 0);
    };

    render() {
        const { prodObj } = this.props;
        const { imageUrl, labelWidths } = this.state;
        // console.log('lastIndex2--->',this.props.lastIndex2);

        return (
            <>
                {/* Image */}
                {imageUrl && (
                    <image 
                        x={prodObj.x} 
                        y={prodObj.y - prodObj.drawHeight * this.props.index} 
                        width={prodObj.drawWidth} 
                        height={prodObj.drawHeight} 
                        href={imageUrl} 
                        preserveAspectRatio="none"
                         style={{outline: prodObj?.mark_height_issue === true ? "solid 4px red" : "solid 1px rgb(204, 204, 204)"}}
                    />
                )}

                {/* Top Label */}
                {this.props?.topLabel && (
                    <>
                        <rect 
                            x={prodObj.x + (prodObj.drawWidth - labelWidths.top) / 2 } 
                            y={prodObj.y - prodObj.drawHeight * this.props.lastIndex2 + 10} 
                            width={labelWidths.top} 
                            height={18} 
                            fill="white" 
                            stroke="black"
                        />
                        <text 
                            ref={this.textRefs.top}
                            x={prodObj.x + prodObj.drawWidth / 2} 
                            y={prodObj.y - prodObj.drawHeight * this.props.lastIndex2 + 25} 
                            fill="black" 
                            fontSize="16" 
                            textAnchor="middle"
                        >
                            {this.props?.topLabel}
                        </text>
                    </>
                )}

                {/* Product Face Label */}
                {this.props?.productFace && (
                    <>
                        <rect 
                            x={prodObj.x + (prodObj.drawWidth - labelWidths.middle2) / 2 } 
                            // y={prodObj.y + prodObj.drawHeight / 2 - 20} 
                            y={ this.props.lastIndex2 + 1 === 2 ? prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex2) / 2) + 70 :prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex2) / 2) + 30}
                            width={labelWidths.middle2} 
                            height={18} 
                            fill="white" 
                            stroke="black"
                        />
                        <text 
                            ref={this.textRefs.middle2}
                            x={prodObj.x + prodObj.drawWidth / 2} 
                            // y={prodObj.y + prodObj.drawHeight / 2 - 10} 
                            y={this.props.lastIndex2 + 1 === 2 ? prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex2) / 2) + 85: prodObj.y - (prodObj.drawHeight * Math.floor(this.props.lastIndex2) / 2) + 45} 
                            fill="black" 
                            fontSize="16"
                            fontWeight="medium"
                            textAnchor="middle"
                        >
                            {this.props?.productFace}
                        </text>
                    </>
                )}

                {/* Middle Label */}
                {this.props?.middleLabel && (
                    <>
                        <rect 
                            x={prodObj.x + (prodObj.drawWidth - labelWidths.middle) / 2} 
                            y={prodObj.y + prodObj.drawHeight / 2 - 6} 
                            width={labelWidths.middle} 
                            height={18} 
                            fill="white" 
                            stroke="black"
                        />
                        <text 
                            ref={this.textRefs.middle}
                            x={prodObj.x + prodObj.drawWidth / 2} 
                            y={prodObj.y + prodObj.drawHeight / 2 + 8} 
                            fill="black" 
                            fontSize="16"
                            fontWeight="medium"
                            textAnchor="middle"
                        >
                            {this.props?.middleLabel}
                        </text>
                    </>
                )}

                {/* Bottom Label */}
                {this.props?.bottomLabel && (
                    <>
                        <rect 
                            x={prodObj.x + (prodObj.drawWidth - labelWidths.bottom) / 2} 
                            y={prodObj.y + prodObj.drawHeight - 20} 
                            width={labelWidths.bottom} 
                            height={18} 
                            fill="white" 
                            stroke="black"
                        />
                        <text 
                            ref={this.textRefs.bottom}
                            x={prodObj.x + prodObj.drawWidth / 2} 
                            y={prodObj.y + prodObj.drawHeight - 6} 
                            fill="black" 
                            fontSize="16" 
                            textAnchor="middle"
                        >
                            {this.props?.bottomLabel}
                        </text>
                    </>
                )}
            </>
        );
    }
}



export class FullRenderProdImage extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
            prodObj: null,
        };
    }
    
    componentDidMount() {
        this.getBase64FromUrl(this.props.prodObj.imageUrl).then(returnimage => {
            let cprodobj = this.props.prodObj;
            cprodobj["baseUrl"] = returnimage;

            this.setState({ prodObj: cprodobj },()=>{
                this.props.handleloadedprodcount()
            });
        })
    }

    getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();

        return new Promise((resolve) => {
            let newblob = new Blob([blob], {type: 'image/png'});

            const reader = new FileReader();
            reader.readAsDataURL(newblob); 
            reader.onloadend = () => {
                const base64data = reader.result;   
                resolve(base64data);
            }
        });
    }
    
    render() {
        let prodObj = this.state.prodObj;

        return (<>
            {prodObj?
                <image crossOrigin='anonymous' pointerEvents="all" preserveAspectRatio="none" x={prodObj.x} y={prodObj.y} width={prodObj.drawWidth} height={prodObj.drawHeight} xlinkHref={prodObj.baseUrl} style={{outline: prodObj?.mark_height_issue === true ? "solid 4px red" : "solid 1px rgb(204, 204, 204)"}} />
            :<></>}

            {/* Only show red dot if hasPriceTag is false */}
            {prodObj?.isHanged && !prodObj?.hasPriceTag &&
                <circle key={prodObj?.pegRefCode} cx={prodObj?.pegDrawX} cy={prodObj?.pegDrawY-40} r={2} fill="red" stroke="red" />
            }
        </>);
    }
}


// export class StackRenderProdImage extends React.Component{
//     constructor(props) {
//         super(props)
//         this.state = {
//             prodUrl: null,
//         };
//     }
    
//     componentDidMount() {
       
//         this.getBase64FromUrl(this.props.prodObj.imageUrl).then(returnimage => {
//             /* let cprodobj = this.props.prodObj;
//             cprodobj["baseUrl"] = returnimage; */

//             this.setState({ prodUrl: returnimage });
//         })
//     }

//     getBase64FromUrl = async (url) => {
//         const data = await fetch(url);
//         const blob = await data.blob();

//         return new Promise((resolve) => {
//           const reader = new FileReader();
//           reader.readAsDataURL(blob); 
//           reader.onloadend = () => {
//             const base64data = reader.result;   
//             resolve(base64data);
//           }
//         });
//     }
    
//     render() {
//         let prodObj = this.props.prodObj;
//         let prodUrl = this.state.prodUrl;

//         return (<>
//             <image crossOrigin='anonymous' pointerEvents="all" preserveAspectRatio="none" x={prodObj.x} y={prodObj.y - prodObj.drawHeight*this.props.index} width={prodObj.drawWidth} height={prodObj.drawHeight} href={(prodUrl?prodUrl:prodObj.imageUrl)} style={{outline: "solid 1px rgb(204, 204, 204)"}} />
//         </>);
//     }
// }

export class StackRenderProdImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prodUrl: null,
        };
    }

    componentDidMount() {
        this.loadImageWithPromise(this.props.prodObj.imageUrl)
            .then((returnimage) => {
                this.setState({ prodUrl: returnimage });
            })
            .catch((error) => {
                console.error("Error loading image:", error);
            });
    }

    loadImageWithPromise = async (url) => {
        try {
            const base64Url = await this.getBase64FromUrl(url);
            await this.waitForImageToLoad(base64Url);
            return base64Url;
        } catch (error) {
            console.error("Error in image loading:", error);
            throw error;
        }
    };

    getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();

        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                resolve(reader.result);
            };
        });
    };

    waitForImageToLoad = (imageUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = imageUrl;
            img.onload = () => resolve(imageUrl);
            img.onerror = reject;
        });
    };

    render() {
        let prodObj = this.props.prodObj;
        let prodUrl = this.state.prodUrl;

        return (
            <>
                <image
                    crossOrigin="anonymous"
                    pointerEvents="all"
                    preserveAspectRatio="none"
                    x={prodObj.x}
                    y={prodObj.y - prodObj.drawHeight * this.props.index}
                    width={prodObj.drawWidth}
                    height={prodObj.drawHeight}
                    href={prodUrl ? prodUrl : prodObj.imageUrl}
                    style={{outline: prodObj?.mark_height_issue === true ? "solid 4px red" : "solid 1px rgb(204, 204, 204)"}}
                />

                {/* Show hangged peg hole in red color */}
                {prodObj?.isHanged && 
                  <circle key={prodObj?.pegRefCode} cx={prodObj?.pegDrawX} cy={prodObj?.pegDrawY-40} r={2} fill="red" stroke="red" />
                 }
            </>
        );
    }
}